module.exports = __webpack_public_path__ + "img/wine-placeholder-rose.34322d6c.png";